import { render, staticRenderFns } from "./vButton.vue?vue&type=template&id=589c0826&scoped=true&"
import script from "./vButton.vue?vue&type=script&lang=js&"
export * from "./vButton.vue?vue&type=script&lang=js&"
import style0 from "./vButton.vue?vue&type=style&index=0&id=589c0826&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c0826",
  null
  
)

export default component.exports